var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('span',[_vm._v(_vm._s(_vm.value)+" ")]):_c('span',[_c('i',[_vm._v("[empty]")])])
}
var staticRenderFns = []

export { render, staticRenderFns }